module.exports = __webpack_public_path__ + "img/main-KV.c91321f4.png";